import './Link.scss';
import { NavLink } from 'react-router-dom';

const Link = ({ url, text, icon }) => {
  return (
    <NavLink className={`nav-link ${url === '/auth' ? 'auth' : ''}`} to={url}>
      <span>{icon}</span>
      <p>{text}</p>
    </NavLink>
  );
};

export default Link;
